import auth from './auth'
import signup from './signup'
import profile from './profile'
import leaderboards from './leaderboards'
import invite from './invite'
import forgotPassword from './forgot-password'
import changePassword from './change-password'
import verifyEmail from './verify-email'
import results from './results'
import league from './league'
import predictions from './predictions'
import admin from './admin'
import player from './player'

export default {
  auth,
  signup,
  profile,
  leaderboards,
  invite,
  forgotPassword,
  changePassword,
  verifyEmail,
  results,
  league,
  predictions,
  admin,
  player
}
